var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"zoomable-div",style:({ transform: `scale(${_vm.scale})` }),on:{"wheel":function($event){return _vm.zoom($event)}}},[_vm._v(" 缩放我 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }